import { fileUrl } from "@/lib/api";

// Cream-surface logo mark (the favicon is the teal P mark on cream, blends into light headers).
export function BrandLockup({ className = "", onClick, size = "md" }) {
  const markH = size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const word = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <button onClick={onClick} data-testid="brand-lockup" className={`group flex items-center gap-2.5 ${className}`}>
      <img src="/favicon.png" alt="Playbook" className={`${markH} rounded-[10px] object-cover transition-transform group-hover:-translate-y-0.5`} />
      <span className="flex flex-col items-start leading-none">
        <span className={`font-display font-extrabold tracking-[0.02em] text-[#35606E] ${word}`}>PLAYBOOK</span>
        <span className="mt-0.5 text-[9px] font-semibold uppercase tracking-[0.42em] text-[#6E97A2]">Distro</span>
      </span>
    </button>
  );
}

// Full official logo image — cream on light, black on dark surfaces.
export function BrandLogoImage({ variant = "cream", className = "" }) {
  const path = variant === "black"
    ? "/api/files/playbook-data/brand/logo-black.png"
    : "/api/files/playbook-data/brand/logo-cream.webp";
  return <img src={fileUrl(path)} alt="Playbook Distro" className={className} />;
}
